import React from 'react';
export function LogicStack() {
  const items = [{
    name: 'Ebook Principal: El Método Barrita Pro',
    value: '$28.000'
  }, {
    name: 'Bono 1 — Calculadora Mayorista Pro',
    value: '$5.500'
  }, {
    name: 'Bono 2 — Guía Sustitutos Sin Gastar',
    value: '$4.000'
  }, {
    name: 'Bono 3 — 15 Recetas Sin Horno',
    value: '$6.500'
  }, {
    name: 'Bono 4 — Barritas Veganas Express',
    value: '$4.500'
  }, {
    name: 'Bono 5 — Método Freezado 3 Meses',
    value: '$3.000'
  }, {
    name: 'Bono 6 — Kit Etiquetas Pro',
    value: '$1.500'
  }];
  return <section className="bg-[#1E293B] text-white py-12 sm:py-20 px-4 text-center border-t border-b border-[rgba(255,255,255,0.06)]" data-id="element-133">
      <div className="max-w-[780px] mx-auto" data-id="element-134">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-135" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-white tracking-tight leading-[1.2]" data-id="element-136">
          Todo lo que recibís hoy
        </h2>

        <ul className="list-none max-w-[520px] mx-auto my-7" data-id="element-137">
          {items.map((item, idx) => <li key={idx} className="flex justify-between items-center py-[13px] border-b border-[rgba(255,255,255,0.06)] text-[15px] text-[#94A3B8] transition-colors duration-[0.25s] hover:text-white last:border-b-0" data-id="element-138">
              <span data-id="element-139">{item.name}</span>
              <span className="text-[#475569] line-through text-sm flex-shrink-0 ml-4" data-id="element-140">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="max-w-[520px] mx-auto mb-8 flex justify-between items-center font-montserrat text-base font-bold text-white border-t-2 border-[#F97316] pt-4" data-id="element-141">
          <span data-id="element-142">Valor total real:</span>
          <span className="text-[#475569] text-lg line-through" data-id="element-143">$53.000</span>
        </div>

        <p className="text-[#94A3B8] text-[15px] mb-2 font-medium" data-id="element-144">
          Tu precio hoy:
        </p>

        <p className="font-montserrat text-[60px] font-black text-white leading-none mb-7 tracking-tight" data-id="element-145">
          <span className="text-[28px] align-super text-[#F97316]" data-id="element-146">$</span>
          16.990
        </p>

        <a href="#" className="inline-block bg-[#F97316] text-white font-montserrat text-base font-extrabold uppercase tracking-[1.5px] py-5 px-[52px] rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#C2410C] hover:shadow-[0_8px_32px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 active:translate-y-0" style={{
        animation: 'pulse-cta 2.5s ease infinite'
      }} data-id="element-147">
          AGREGAR AL CARRITO &gt;&gt;
        </a>

        <p className="text-[#475569] text-xs mt-[14px] tracking-[0.5px]" data-id="element-148">
          Pago único · Acceso inmediato · Sin cuotas
        </p>

        <div className="mt-8 max-w-[320px] mx-auto opacity-80" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/19bPpnrU44K19JyvPWSjFW/20260325_0941_Image_Generation_remix_01kmjg6ctfevbtzss93cbgdpb4-removebg-preview.png" alt="Pago seguro garantizado — Visa, Mastercard, Maestro, PayPal" className="w-full" data-id="element-150" />
        </div>

        <div className="mt-10 max-w-[520px] mx-auto rounded-2xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.3)]" data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/k1B6QpyScMUAVQdZikMNjn/1.png" alt="Mercado Líder Platinum — Miles de clientes satisfechos, +200.000 ventas en MercadoLibre" className="w-full block" data-id="element-152" />
        </div>
      </div>
    </section>;
}